import { ReactNode } from 'react';
import { NodeOrResolver } from './types';

// eslint-disable-next-line import/prefer-default-export
export const getNode = (node: NodeOrResolver, isSelected: boolean): ReactNode =>
  typeof node !== 'function' ? node : node(isSelected);
